import { render } from "./Menu.vue?vue&type=template&id=77e74b08"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=77e74b08&lang=scss"
script.render = render

export default script